export const Constants = {
    // 公司id  1548210858814631936  1548223800395059200
    // id: '1549220461870383104' // 天津id
    // id: 1869997363441164288 // 南方id
    // id: '1549220461870383105'
    id: '1549220461870383105' // 宁夏id
}